import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DriverIdentificationService } from '../../services/driver-identification.service';

type PanelState = 'collapsed' | 'expanded';

@Component({
  selector: 'app-driver-identification-panel',
  templateUrl: './driver-identification-panel.component.html',
  styleUrls: ['./driver-identification-panel.component.scss']
})
export class DriverIdentificationPanelComponent implements OnInit {

  visible = false;
  panelState: PanelState = 'expanded';

  panelStatus$ = this.driverIdentificationService.panelStatus$;
  constructor(
    private driverIdentificationService: DriverIdentificationService,
    private cdr: ChangeDetectorRef

  ) {}

  ngOnInit(): void {

    this.driverIdentificationService.openPanel$
      .subscribe(open => {
        console.log('Driver Identification Panel open state:', open);
        this.visible = open;

        if(open){
          this.panelState = 'expanded';
        }

        this.cdr.detectChanges();
      });

  }

  get panelClasses(){
    return {
      'is-hidden': !this.visible,
      'is-collapsed': this.panelState === 'collapsed',
      'is-expanded': this.panelState === 'expanded'
    };
  }

  collapsePanel(){
    this.panelState = 'collapsed';
  }

  expandPanel(){
    this.panelState = 'expanded';
  }

  identifyDriver(){
    console.log('Identificando conductor...');
  }

  toggleDisplayOnPanel(){
    if(this.panelState === 'collapsed'){
      this.expandPanel();
    } else {
      this.collapsePanel();
    }
  }

}
